export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-battery-half-507e17eea7935b94ab6e4be812f0501f.svg";